import { defineMessages } from 'react-intl'

/** Shared i18n message descriptors for brand config strings */

export const leConfigMessages = defineMessages({
  searchBarText: {
    id: 'BijKy3abfC0B5VLOxR0o',
    defaultMessage: 'Search great offers for',
    description: 'Search bar placeholder text for Luxury Escapes family brands',
  },
  searchFormTitle: {
    id: '_lc0nBKTiDOmhUb7jaGo',
    defaultMessage: 'The world’s best escapes, handpicked by experts',
    description: 'Hero section title for Luxury Escapes family search form',
  },
  headMetaTitle: {
    id: 'asMhqxxhS1snrlyF5GAH',
    defaultMessage: 'Handpicked Escapes at the Best Prices on Earth',
    description: 'Meta title suffix for destination product pages (Luxury Escapes)',
  },
  headDefaultTitle: {
    id: 'xWRGa0e7cJW5bhPXqrxE',
    defaultMessage: 'Luxury Escapes - Handpicked Escapes at the Best Prices on Earth',
    description: 'Default page title for Luxury Escapes used in SEO meta tags',
  },
  headDefaultDescription: {
    id: '-Frv3aJqbZTK0zbS1xOL',
    defaultMessage: 'Find the latest luxury travel ideas & exclusive special offers at insider prices. Save on holiday travel & accommodation packages with Luxury Escapes.',
    description: 'Default meta description for Luxury Escapes used in SEO tags',
  },
})

export const whiteLabelConfigMessages = defineMessages({
  searchBarText: {
    id: '1cp4crcANJeAHx--69rl',
    defaultMessage: 'Search',
    description: 'Search bar placeholder text for white-label brands',
  },
  searchFormTitle: {
    id: 'yq1_Bk95h9WsCimdG7Ad',
    defaultMessage: 'The best value holidays are right here',
    description: 'Hero section title for white-label brand search form',
  },
  headMetaTitle: {
    id: 'OGVT4jPEMpBsswgxgwAb',
    defaultMessage: 'Travel Deals & Holiday Package Deals',
    description: 'Meta title suffix for destination product pages (white-label brands)',
  },
  headDefaultDescription: {
    id: '3BCIgk0ZXhvmFMPfqgky',
    defaultMessage: 'Travel is the one thing you buy that makes you richer. Check out travel deals & holiday package deals for your next adventure. Grab a bargain today!',
    description: 'Default meta description for white-label brands used in SEO tags',
  },
})

export const cudoConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'bvblEpmNKbhdVc4WuVR8',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Cudo',
    description: 'Default page title for the Cudo brand used in SEO meta tags',
  },
})

export const dealsConfigMessages = defineMessages({
  headDefaultTitle: {
    id: '3AA-HrExm3xN1-s7LEt6',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Deals',
    description: 'Default page title for the Deals brand used in SEO meta tags',
  },
})

export const scooponConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'pF-NgSGTTr8HI4njn-dX',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Scoopon',
    description: 'Default page title for the Scoopon brand used in SEO meta tags',
  },
})

export const treatmeConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'u_qUwIgDe-y2LDZCqiwY',
    defaultMessage: 'Travel Deals & Holiday Package Deals | TreatMe',
    description: 'Default page title for the TreatMe brand used in SEO meta tags',
  },
})

export const leAgentHubConfigMessages = defineMessages({
  headMetaTitle: {
    id: 'cyzWYLZspkV81g6ETNmm',
    defaultMessage: 'LE Agent Hub - Earn commission on the world’s best travel deals',
    description: 'Meta title suffix for destination product pages (LE Agent Hub)',
  },
  headDefaultTitle: {
    id: 'CLhCOcIefrSa-ztldq--',
    defaultMessage: 'LE Agent Hub - Earn commission on the world’s best travel deals',
    description: 'Default page title for the LE Agent Hub used in SEO meta tags',
  },
  headDefaultDescription: {
    id: 'A3Ak_N0fcK85wLi9jUnw',
    defaultMessage: 'The only way to get access to Luxury Escapes Exclusive travel offers - give your clients access to the very best offers globally',
    description: 'Default meta description for the LE Agent Hub used in SEO tags',
  },
})

export const cvfrConfigMessages = defineMessages({
  headMetaTitle: {
    id: 'dcaMNUSPEcjEoFlIoAe3',
    defaultMessage: 'CVFR Holidays - Earn commission on the world\'s best travel deals',
    description: 'Meta title suffix for destination product pages (CVFR Holidays)',
  },
  headDefaultTitle: {
    id: 'YbPSjcOV-UKD9PFwZdvn',
    defaultMessage: 'CVFR Holidays - Earn commission on the world\'s best travel deals',
    description: 'Default page title for CVFR Holidays used in SEO meta tags',
  },
})

/** Shared message descriptors for "How it works" / "Why book with us" cards */
export const howItWorksMessages = defineMessages({
  // Tour offer type (shared: base, white-label, LE Agent Hub, CVFR)
  tourBestPriceGuaranteeTitle: {
    id: 'tMZS7wYi8tuAuf0H906P',
    defaultMessage: 'Best Price Guarantee',
    description: 'How it works card title: Best Price Guarantee (tour)',
  },
  tourBestPriceGuaranteeContent: {
    id: 'wp4slVksKGlOLelvh-Dm',
    defaultMessage: 'Found a better price? We’ll match it… plus more.',
    description: 'How it works card content: Best Price Guarantee (tour)',
  },
  tourHandpickedPartnersTitle: {
    id: 'OsFBVCv490zIC-OH8qDA',
    defaultMessage: 'Handpicked Partners',
    description: 'How it works card title: Handpicked Partners (tour)',
  },
  tourHandpickedPartnersContent: {
    id: 'Hh2H6TJB9T703g_k-Jmh',
    defaultMessage: 'We work with the world’s most loved brands in travel',
    description: 'How it works card content: Handpicked Partners (tour)',
  },
  tourCuratedByExpertsTitle: {
    id: 'qml8R0DtWXMszCqBdI6v',
    defaultMessage: 'Curated By Tour Experts',
    description: 'How it works card title: Curated By Tour Experts (tour)',
  },
  tourCuratedByExpertsContent: {
    id: 'O2BJTU7LfwFnPiC7pmC0',
    defaultMessage: 'Saving you time researching and planning',
    description: 'How it works card content: Curated By Tour Experts (tour)',
  },
  // Hotel offer type (base config / LE family)
  hotelWePriceMatchTitle: {
    id: '7ZkPgwvqLEhkFSqUKpny',
    defaultMessage: 'We price match',
    description: 'How it works card title: We price match (hotel, LE family)',
  },
  hotelWePriceMatchContent: {
    id: 'nJ9MF-2wUJw58DF9dUBC',
    defaultMessage: 'If you find a better price, we’ll match it',
    description: 'How it works card content: We price match (hotel, LE family)',
  },
  hotelChangeOfMindRefundTitle: {
    id: 'wVWnf1lIwYLO7A64ecdt',
    defaultMessage: '7-day ‘change of mind’ refund',
    description: 'How it works card title: 7-day change of mind refund (hotel)',
  },
  hotelChangeOfMindRefundContent: {
    id: 'MafTtf7AK9FqKVtflbvt',
    defaultMessage: 'Get a full refund on your booking (excludes flights, experiences and the service fee paid on deposit bookings)',
    description: 'How it works card content: 7-day change of mind refund (hotel)',
  },
  hotelVipInclusionsTitle: {
    id: '3Psru2jLEOiiMk7oyGge',
    defaultMessage: 'VIP Inclusions',
    description: 'How it works card title: VIP Inclusions (hotel, LE family)',
  },
  hotelVipInclusionsContent: {
    id: 'yOc5GxNI0Usu0y5eGulI',
    defaultMessage: 'You get a lot more than just a bed in a room',
    description: 'How it works card content: VIP Inclusions (hotel, LE family)',
  },
  hotelBuyNowTitle: {
    id: 'aq7z2mOeRQZVXK4CB5hH',
    defaultMessage: 'Buy now, choose dates later',
    description: 'How it works card title: Buy now, choose dates later (hotel)',
  },
  hotelBuyNowContent: {
    id: 'bMCGXeF2ayTGhRxwQIp_',
    defaultMessage: 'Lock in a deal today, choose dates when you’re ready',
    description: 'How it works card content: Buy now, choose dates later (hotel)',
  },
  // Last minute hotel offer type (base config / LE Agent Hub / CVFR)
  lmhUnbeatableValueTitle: {
    id: 'sQtmKz06962SlcCvkydj',
    defaultMessage: 'Unbeatable value',
    description: 'How it works card title: Unbeatable value (last minute hotel)',
  },
  lmhUnbeatableValueContent: {
    id: '_Na4zMlkx1dZONqI1gQ0',
    defaultMessage: 'Up to 15% (or more) off the best available rate',
    description: 'How it works card content: Unbeatable value (last minute hotel)',
  },
  lmhExclusiveExtrasTitle: {
    id: 'wVQXwL-A-icFCzhZQiq8',
    defaultMessage: 'Exclusive extras',
    description: 'How it works card title: Exclusive extras (last minute hotel)',
  },
  lmhExclusiveExtrasContent: {
    id: 'mBYoV8HVF0RgomO_Xudb',
    defaultMessage: 'Special inclusions to add a touch of luxury',
    description: 'How it works card content: Exclusive extras (last minute hotel)',
  },
  lmhHandPickedHotelsTitle: {
    id: 'QRiUVTcer1xbfPgeD5g_',
    defaultMessage: 'Hand picked hotels',
    description: 'How it works card title: Hand picked hotels (last minute hotel)',
  },
  lmhHandPickedHotelsContent: {
    id: 'G95ZlbHzYskQ7zVtkVhC',
    defaultMessage: 'The best hotels and resorts, curated by our team of experts',
    description: 'How it works card content: Hand picked hotels (last minute hotel)',
  },
  lmhInstantBookingTitle: {
    id: 'cBMO81qX48pwF4eRSfoV',
    defaultMessage: 'Instant booking',
    description: 'How it works card title: Instant booking (last minute hotel)',
  },
  lmhInstantBookingContent: {
    id: '6pnPOMl_g4yc5Jo_RHpl',
    defaultMessage: 'Book with ease and get instant confirmation of your stay',
    description: 'How it works card content: Instant booking (last minute hotel)',
  },
  // White-label hotel (Cudo, Deals, Scoopon, TreatMe)
  wlHotelBestPricesTitle: {
    id: 'MXmyre6vHaqxV21LTSqJ',
    defaultMessage: 'Best prices',
    description: 'How it works card title: Best prices (white-label hotel)',
  },
  wlHotelBestPricesContent: {
    id: 'N93LwdlDptE1XNp87UbK',
    defaultMessage: 'We go direct to ensure you get the best price possible',
    description: 'How it works card content: Best prices (white-label hotel)',
  },
  wlHotelPurchaseWithConfidenceTitle: {
    id: 'kBqbnMesrkn84rnGbqKQ',
    defaultMessage: 'Purchase with confidence',
    description: 'How it works card title: Purchase with confidence (white-label hotel)',
  },
  wlHotelPurchaseWithConfidenceContent: {
    id: 'UH2AWPIiD_AnaVs88M3J',
    defaultMessage: "We offer a 7-day 'Change of Mind' no questions asked guarantee",
    description: 'How it works card content: Purchase with confidence (white-label hotel)',
  },
  wlHotelQualityGuaranteedTitle: {
    id: 'warvFTakbcr-lY7UxY_o',
    defaultMessage: 'Quality guaranteed',
    description: 'How it works card title: Quality guaranteed (white-label hotel)',
  },
  wlHotelQualityGuaranteedContent: {
    id: 'DGbo_RhdCbrXAQmo1PMm',
    defaultMessage: 'We test the beds to assure you have an amazing holiday',
    description: 'How it works card content: Quality guaranteed (white-label hotel)',
  },
  // LE Agent Hub hotel (different title casing from base)
  agentHubHotelBestPriceTitle: {
    id: 'G0MI2FGG-R48BZg0z_PU',
    defaultMessage: 'Best price guarantee',
    description: 'How it works card title: Best price guarantee (LE Agent Hub hotel)',
  },
})

/** Shared message descriptors for static page titles used across brand configs */
export const staticPageMessages = defineMessages({
  support: {
    id: 'QlnsuX0UR_VyENdutI9k',
    defaultMessage: 'Support',
    description: 'Static page title for the Support page used in navigation',
  },
  termsAndConditions: {
    id: 'Alx0VXYdSUr0dhFp1x_Z',
    defaultMessage: 'Terms & Conditions',
    description: 'Static page title for the Terms & Conditions page used in navigation',
  },
  bookingPolicies: {
    id: 'HF4w2FHSauPwGa87KZ59',
    defaultMessage: 'Booking & Refund Policies',
    description: 'Static page title for the Booking & Refund Policies page used in navigation',
  },
  privacyPolicy: {
    id: 'ld8v_7j8N5oAi7vDU2vi',
    defaultMessage: 'Privacy Policy',
    description: 'Static page title for the Privacy Policy page used in navigation',
  },
  flights: {
    id: 'V6DYHCuB6j0geuFnWb4P',
    defaultMessage: 'Flights',
    description: 'Static page title for the Flights page used in navigation',
  },
  frequentFlyerPrograms: {
    id: 'dsgxKVBDwEdJuRNTjwRs',
    defaultMessage: 'Frequent Flyer Programs',
    description: 'Static page title for the Frequent Flyer Programs page used in navigation',
  },
  bestPriceGuarantee: {
    id: 'FDRnbP7tTOmgAHYAiB5g',
    defaultMessage: 'Best Price Guarantee',
    description: 'Static page title for the Best Price Guarantee page used in navigation',
  },
  luxuryEscapesGiftCards: {
    id: 'sA_tbdvsdIJnykONtloK',
    defaultMessage: 'Luxury Escapes Gift Cards',
    description: 'Static page title for the Luxury Escapes Gift Cards page used in navigation',
  },
  specialProductsPromotions: {
    id: 'RF2yPw4wJ1ybCmliIS-F',
    defaultMessage: 'Special Products & Promotions',
    description: 'Static page title for the Special Products & Promotions page used in navigation',
  },
  refundPolicy: {
    id: 'Sl-atapKv0hsLXuNWk_w',
    defaultMessage: 'Refund Policy',
    description: 'Static page title for the Refund Policy page used in navigation',
  },
  aboutUs: {
    id: '851XClwSGcPZqXik-Mc3',
    defaultMessage: 'About Us',
    description: 'Static page title for the About Us page used in navigation',
  },
  careersAndCulture: {
    id: 'Y7w_W3EP6Kk9cPjE9ybB',
    defaultMessage: 'Careers & Culture',
    description: 'Static page title for the Careers & Culture page used in navigation',
  },
  travelProtection: {
    id: 'pBnL-HFCSiAe00dJZrGP',
    defaultMessage: 'Travel Protection',
    description: 'Static page title for the Travel Protection page used in navigation',
  },
  travelProtectionXcover: {
    id: 'kO8Eccckl3BtokLbJptG',
    defaultMessage: 'Travel Protection - xcover',
    description: 'Static page title for the Travel Protection xcover page used in navigation',
  },
  contactUs: {
    id: 'ljuoa9dIKu9Cc38NzJ9l',
    defaultMessage: 'Contact Us',
    description: 'Static page title for the Contact Us page used in navigation',
  },
  latestNews: {
    id: 'yR1nxtcOEqUWmRjLNB95',
    defaultMessage: 'Latest News',
    description: 'Static page title for the Latest News page used in navigation',
  },
  buyNowChooseDatesLater: {
    id: 'K268pMOxgLxnHWdH4ivS',
    defaultMessage: 'Buy now, choose dates later',
    description: 'Static page title for the Buy now choose dates later page used in navigation',
  },
  tourWithConfidence: {
    id: 'J2LLNsg3yjFqRNnv-rLn',
    defaultMessage: 'Tour with confidence',
    description: 'Static page title for the Tour with confidence page used in navigation',
  },
  escapeWithConfidence: {
    id: 'akTB8MjOdv2y1f6JPIPb',
    defaultMessage: 'Escape with confidence',
    description: 'Static page title for the Escape with confidence page used in navigation',
  },
  becomeAnAffiliatePartner: {
    id: 'jy0xDnt0C3rmYnqNkIsQ',
    defaultMessage: 'Become an Affiliate Partner',
    description: 'Static page title for the Become an Affiliate Partner page used in navigation',
  },
  luxPlusTermsAndConditions: {
    id: 'HwsT0FhjvVmcUaChzC4M',
    defaultMessage: 'LuxPlus+ Terms & Conditions',
    description: 'Static page title for the LuxPlus+ Terms & Conditions page used in navigation',
  },
  societeTermsAndConditions: {
    id: '72HpGahLr3XdZBxGucx3',
    defaultMessage: 'Société Terms & Conditions',
    description: 'Static page title for the Société Terms & Conditions page used in navigation',
  },
  societeFAQs: {
    id: 'hnENeg-43F4m735ZOwpq',
    defaultMessage: 'Société FAQs',
    description: 'Static page title for the Société FAQs page used in navigation',
  },
  shopFAQs: {
    id: 'bqJEd44pu2_rNEc1Ur0L',
    defaultMessage: 'Shop FAQs',
    description: 'Static page title for the Shop FAQs page used in navigation',
  },
  shopTermsAndConditions: {
    id: 'ZttV2VMEr6-gTV9Miy33',
    defaultMessage: 'Shop Terms And Conditions',
    description: 'Static page title for the Shop Terms And Conditions page used in navigation',
  },
  directMaldivesFlights: {
    id: 'IxQa3pA55Hu_EXYVTIsI',
    defaultMessage: 'Direct Maldives Flights',
    description: 'Static page title: Direct Maldives Flights (LE Agent Hub)',
  },
})

/** Shared message descriptors for loyalty unit labels */
export const loyaltyUnitMessages = defineMessages({
  pointsCount: {
    id: 'OQGYhhYKaTqrHhqTQwr2',
    defaultMessage: '{count, plural, one {# point} other {# points}}',
    description: 'Pluralised loyalty points count label, e.g. "5 points"',
  },
  pointsAbbreviationCount: {
    id: 'QQcbOIoggWUWxyuLffKC',
    defaultMessage: '{count, plural, one {# pt} other {# pts}}',
    description: 'Abbreviated pluralised loyalty points count label, e.g. "5 pts"',
  },
  bonusPointsCount: {
    id: 'Nq-QzAJFEA9GXvMgk2s_',
    defaultMessage: '{count, plural, one {# bonus point} other {# bonus points}}',
    description: 'Pluralised loyalty bonus points count label, e.g. "5 bonus points"',
  },
  bonusPointsAbbreviationCount: {
    id: 'LpwdDXrvm5WNx7O3eOgr',
    defaultMessage: '{count, plural, one {# bonus pt} other {# bonus pts}}',
    description: 'Abbreviated loyalty bonus points count, e.g. "5 bonus pts"',
  },
  statusCreditsCount: {
    id: 'a5W01EYIIMZ5EdYUewxP',
    defaultMessage: '{count, plural, one {# status credit} other {# status credits}}',
    description: 'Loyalty status credits count, e.g. "5 status credits"',
  },
  pointsAbbreviationPlural: {
    id: 'eamURWA8Wv13yL5yCM0m',
    defaultMessage: 'pts',
    description: 'Abbreviated loyalty points unit (always plural), e.g. "pts" in "500 pts"',
  },
})
